import React from 'react';

const ReviewStatus = ({ status }) => {
    const reviewStatusLabel = ["Negative", "Neutral", "Positive"];
    const reviewStatusColor = ["bg-red-500", "bg-gray-500", "bg-blue-500"];
    const reviewStatusIcon = [
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-7.536 5.879a1 1 0 001.415 0 3 3 0 014.242 0 1 1 0 001.415-1.415 5 5 0 00-7.072 0 1 1 0 000 1.415z" clipRule="evenodd" />
        </svg>,

        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
            <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
        </svg>,
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z" clipRule="evenodd" />
        </svg>,

    ];
    return (
        <div className="flex items-center mb-2">
            <span class={`inline-flex items-center justify-center p-2 ${reviewStatusColor[status]} rounded-md shadow-lg`}>
                {reviewStatusIcon[status]}
            </span>
            <h3 class="text-gray-600 dark:text-white text-sm font-medium tracking-tight ml-2">{reviewStatusLabel[status]}</h3>
        </div>
    );
}

export default ReviewStatus;